/**
  * SDK version.
*/
export const VERSION = "2.2.5";
